import { useMemo } from "react";
import type { TokenStatus } from "../../managers/ia/types/ia";
import { monthlyTokenLimit } from "../../managers/license/LicenseState";
import { LICENSES_KEY } from "../../managers/license/queries";
import type { LicensesResponse } from "../../managers/license/types/license.api";
import { useSessionQuery, type LiveState } from "../session/useSessionQuery";
import { useUserProfile } from "../user/useUserProfile";

/** Jetons IA du mois : `total` alloués par la licence, `used` consommés selon le profil. */
export function useIaTokenStatus(): LiveState<TokenStatus> {
    const licenses = useSessionQuery<LicensesResponse>(LICENSES_KEY);
    const profile = useUserProfile();

    return useMemo(
        () => ({
            data:
                licenses.data && profile.data
                    ? {
                          total: monthlyTokenLimit(licenses.data),
                          used: profile.data.monthlySpentTokenCount,
                      }
                    : undefined,
            isLoading: licenses.isLoading || profile.isLoading,
            error: licenses.error ?? profile.error,
            refresh: profile.refresh,
        }),
        [licenses, profile],
    );
}
